import React from 'react';

export const HamburgerIcon = ({ isOpen }) => (
  <div className="w-6 h-5 md:w-7.5 md:h-6 relative flex items-center justify-center">
    <span
      className={`absolute w-6 md:w-7.5 h-[2px] bg-[#F5E6D8] transition-all duration-300 transform ${
        isOpen ? 'rotate-45 translate-y-0' : '-translate-y-[5.5px] md:-translate-y-[7.5px]'
      }`}
    />
    <span
      className={`absolute w-6 md:w-7.5 h-[2px] bg-[#F5E6D8] transition-all duration-300 transform ${
        isOpen ? 'opacity-0 scale-0' : 'opacity-100 scale-100'
      }`}
    />
    <span
      className={`absolute w-6 md:w-7.5 h-[2px] bg-[#F5E6D8] transition-all duration-300 transform ${
        isOpen ? '-rotate-45 translate-y-0' : 'translate-y-[5.5px] md:translate-y-[7.5px]'
      }`}
    />
  </div>
);

export const SearchIcon = () => (
  <svg className="w-[19.9px] h-[19.9px] md:w-[23.5px] md:h-[23.5px] text-[#F5E6D8]" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const UserIcon = () => (
  <svg className="w-[19.9px] h-[19.9px] md:w-[23.5px] md:h-[23.5px] text-[#F5E6D8]" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const CartIcon = () => (
  <svg className="w-[19.9px] h-[19.9px] md:w-[23.5px] md:h-[23.5px] text-[#F5E6D8]" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <rect x="5" y="8" width="14" height="13" rx="2" />
    <path d="M9 8V6a3 3 0 0 1 6 0v2" />
  </svg>
);

export const CloseIcon = () => (
  <svg className="w-6 h-6 text-[#584738]" fill="none" stroke="currentColor" strokeWidth="1.25" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export const HeartIcon = ({ filled = false }) => (
  <svg
    className={`w-6 h-6 transition-colors duration-300 ${
      filled ? 'text-[#F5E6D8] fill-current' : 'text-[#F5E6D8]/75 hover:text-[#F5E6D8] fill-none'
    }`}
    stroke="currentColor"
    strokeWidth="1.25"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
    />
  </svg>
);
